'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const avatarsWithText = "_avatars-with-text_14g9n_1";
const avatars = "_avatars_14g9n_1";
const content = "_content_14g9n_46";
const text = "_text_14g9n_51";
const styles = {
	avatarsWithText: avatarsWithText,
	avatars: avatars,
	content: content,
	text: text
};

const AvatarText = (props) => {
  return React__default.default.createElement("span", {
    "aria-label": props["aria-label"],
    className: styles.text,
    "data-kind": props.kind,
    "data-zds": true,
    // `role="text"` isn't technically valid (yet), but it allows
    // VoiceOver to read the content more clearly and prevents it
    // from splitting text. Axe also complains about this, but will
    // stop when the extension uses `axe-core@4.2.0`. See issue:
    // https://github.com/dequelabs/axe-core/issues/1597
    // eslint-disable-next-line jsx-a11y/aria-role
    role: "text"
  }, props.children);
};
const AvatarsWithText = (props) => {
  var _a, _b;
  const childArray = React.Children.toArray(props.avatars);
  const childCount = React.isValidElement(childArray[0]) ? (_b = (_a = childArray[0].props) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.length : 0;
  const noGap = childCount > 3 && props.size !== "large";
  return React__default.default.createElement(
    "div",
    { "aria-label": props["aria-label"], className: styles.avatarsWithText, "data-no-gap": noGap || void 0, "data-multiline": props.multiline ? "" : void 0, "data-size": props.size, "data-zds": true },
    React__default.default.createElement("div", { className: styles.avatars, "data-zds": true }, props.avatars),
    React__default.default.createElement("div", { className: styles.content, "data-zds": true }, props.children)
  );
};

exports.AvatarText = AvatarText;
exports.AvatarsWithText = AvatarsWithText;
//# sourceMappingURL=AvatarsWithText.cjs.js.map
